import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useIsCorsoCxAgent } from '~/hooks/useIsCorsoAdmin';
import { useStoreId } from '~/providers/StoreUserProvider';

/** Live tracker lookups are the expensive part, so only Corso CX agents pay for them. */
export function useOrderTrackingQuery(storeOrderId: number | undefined) {
  const storeId = useStoreId();
  const isCorsoCx = useIsCorsoCxAgent();

  return useQuery({
    enabled: isCorsoCx && !!storeOrderId,
    throwOnError: false,
    queryKey: ['orderTracking', storeOrderId, storeId],
    queryFn: () => api.store(storeId).order.tracking(`${storeOrderId}`),
  });
}
